module.exports = __webpack_public_path__ + "static/media/testingFinal.b0828827.jpg";